<template>
  <div class="mobile-promo-bar">
    <div class="promo-link" @click="openRegisterModal">
      <img
        :src="promoImages[currentIndex]"
        alt="프로모션"
        class="promo-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePromoBar',
  data() {
    return {
      currentIndex: 0,
      promoImages: [],
      timer: null
    }
  },
  created() {
    for (let i = 1; i <= 10; i++) {
      try {
        const img = require(`@/assets/promo/${String(i).padStart(3, '0')}.png`)
        this.promoImages.push(img)
      } catch (e) {
        break
      }
    }
  },
  mounted() {
    if (this.promoImages.length > 1) {
      this.startSlide()
    }
  },
  beforeUnmount() {
    this.stopSlide()
  },
  methods: {
    startSlide() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.promoImages.length
      }, 1000)
    },
    stopSlide() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    openRegisterModal() {
      window.dispatchEvent(new CustomEvent('open-register-modal'))
    }
  }
}
</script>

<style scoped>
.mobile-promo-bar {
  position: sticky;
  top: 60px;
  z-index: 700;
  background: #1a1a1a;
}

.promo-link {
  display: block;
  width: 100%;
  cursor: pointer;
}

.promo-img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
